import React, {useState, useEffect } from 'react';
import authService from './api-authorization/AuthorizeService'
import MetaDB from './MetaDB';
import SupportUs from './features/supporters/SupportUs';
import EventsList from './features/events/EventsList';

function Home(props) {
    const [authenticated, setAuthenticated] = useState(false);

    useEffect(() => {
        async function fetchData() {
            setAuthenticated(await authService.isAuthenticated());
        }
        fetchData()
    }, []);

    return (
        <div>
            {/*<h2>*/}
            {/*    MetaDB has been migrated to the cloud to address power outage issues caused by last year's extreme weather. However, hosting a large database online comes with significant costs. To help offset these expenses, the supporter membership fee will increase to <b>$65/year</b> starting <u><b>March 1st, 2025</b></u>.*/}

            {/*    Additionally, the download limit will change to <b><u>4 times every 12 hours</u></b> (from the current limit of 12 times every 24 hours) starting <u><b>January 1st, 2026</b></u>.*/}

            {/*    You can renew your supporter membership now at the current rate of <b>$50/year</b> multiple times, even if your membership hasn't expired yet. Take advantage of this offer <a href="/SupporterDonate" target="_blank" rel="noopener noreferrer">here</a> to lock in the lower rate.*/}
            {/*</h2>*/}
            {authenticated && <SupportUs/>}
            <MetaDB/>
            <EventsList />
            {/*<CreateLichessStudy/>*/}
        </div>
    );
}

export default Home;